import { useSnackbar } from 'react-simple-snackbar'

export const useCustomSnackbar = (color = 'success', position = "bottom-right") => {
    let colors = {
        success: 'green',
        error: 'red',
        info: 'blue'
    }
    const [open, close] = useSnackbar({position, style: {backgroundColor: colors[color]}});
    return [open, close];
}